import request from '@/service/request'
const basicUrl = '/scene/v3/Roam'
// 获取漫游列表
export function getRoamList(id) {
    return request.get(basicUrl + `/GetList/${id}`)
}

// 获取漫游详情
export function getRoamDetails(id) {
    return request.get(basicUrl + `/${id}`)
}

// 添加漫游
export function addRoam(data) {
    return request.post(basicUrl + '/Create', data)
}

// 修改漫游
export function editRoam(data) {
    return request.put(basicUrl + `/Update`, data)
}

// 修改漫游视口名称
export function editRoamViewportName(data) {
    return request.put(basicUrl + `/UpdateViewportName`, data)
}

// 修改漫游视口视角
export function editRoamViewportAngle(data) {
    return request.put(basicUrl + `/UpdateViewPort`, data)
}

// 修改漫游名称和速度
export function editRoamNameAndSpeed(data) {
    return request.put(basicUrl + `/UpdateNameAndSpeed`, data)
}

// 删除漫游
export function deleteRoam(id) {
    return request.delete(basicUrl + `/Delete/${id}`)
}

// 删除漫游视口
export function deleteRoamViewport(id) {
    return request.delete(basicUrl + `/DeleteViewport/${id}`)
}

// 删除漫游下所有视口
export function deleteRoamViewportAll(id) {
    return request.delete(basicUrl + `/DeleteAllViewport/${id}`)
}